// For use with FontAwesome checkboxes - we need to re-create the Rails magic with the companion hidden input
$(() => $('.js-checkbox').click(function() {
  const hidden_input_id = $(this).attr('id').replace('-checkbox', '');
  const $hidden_input = $(`#${hidden_input_id}`);
  const new_value = $(this).is(':checked') ? '1' : '0';
  return $hidden_input.val(new_value);
}));
